import { render } from "./CustomerLogos.vue?vue&type=template&id=3be24872&scoped=true&ts=true"
import script from "./CustomerLogos.vue?vue&type=script&lang=ts"
export * from "./CustomerLogos.vue?vue&type=script&lang=ts"

import "./CustomerLogos.vue?vue&type=style&index=0&id=3be24872&scoped=true&lang=css"
import "./CustomerLogos.vue?vue&type=style&index=1&id=3be24872&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be24872"]])

export default __exports__